// Message-catalog locales for the static UI shell (R8 i18n Phase 0).
//
// Distinct from the BCP-47 `locale` formatting preference (useLocale): the
// formatting locale keeps full region granularity (de-DE, fr-CH, en-GB, …)
// for Intl number/date output, while message catalogs exist per LANGUAGE
// only (web/messages/{en,fr,de,es}.json). This module owns the mapping.
//
// Design: docs/plans/2026-07-05-i18n-harness-design.md

export const SUPPORTED_MESSAGE_LOCALES = ['en', 'fr', 'de', 'es'] as const;
export type MessageLocale = (typeof SUPPORTED_MESSAGE_LOCALES)[number];

export const DEFAULT_MESSAGE_LOCALE: MessageLocale = 'en';

/**
 * BCP-47 → catalog language. Language-prefix match (`fr-CH` → `fr`); anything
 * unsupported (it-IT, ja-JP, malformed input) falls back to English rather
 * than erroring — a missing translation is a catalog gap, never a crash.
 */
export function resolveMessageLocale(bcp47: string): MessageLocale {
  const lang = bcp47.toLowerCase().split(/[-_]/)[0] ?? '';
  return (SUPPORTED_MESSAGE_LOCALES as readonly string[]).includes(lang)
    ? (lang as MessageLocale)
    : DEFAULT_MESSAGE_LOCALE;
}
